import {useQuery} from 'react-query';
import getMyStoreComments from '.';
interface IUseGetMyStoreCommentsProps {
  guid?: string;
}
const useGetMyStoreComments = ({guid}: IUseGetMyStoreCommentsProps) => {
  const {data, isLoading} = useQuery(
    ['my-store-comments', guid],
    () => getMyStoreComments(guid),
    {enabled: guid ? true : false},
  );
  return {data, isLoading};
};

export default useGetMyStoreComments;
